import {
  USERS,
  REPEATING_VALUE,
} from 'APP_ROOT/modules/FormBuilder/constants/fieldAutocomplete';
import componentsManager from 'APP_ROOT/modules/FormBuilder/services/componentsManager';

const getAutocompleteSource = props => {
  const {
    options: {
      source: source = USERS,
      settings: { formSchema: { properties = [] } = {} } = {},
      populateFrom,
    } = {},
  } = props;

  if (source === REPEATING_VALUE) {
    const [{ label: [fieldKey = ''] = [] } = {}] =
      Object.values(populateFrom) || [];
    const [{ options = {} } = {}] =
      componentsManager.findFieldsByKey(properties, fieldKey) || [];
    return options?.source || USERS;
  }

  return source;
};

export default getAutocompleteSource;
